import React from 'react';
import _ from 'lodash';

import DropdownSelector from '../DropdownSelector';
import Tippy from '../../ReactTippy';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { messageUtility } from '../../../utilities/messageUtility';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { FormDropdownClearButton } from '../../CommonFormComponents';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import { TAB_KEY_STATUS } from '../../../utilities/constants';

/**
 * DropdownSelectorに準拠する
 *
 * @export
 * @class FieldTreeMainWorkTypesDropdown
 * @props {function} validate
 * @props {function} set
 * @props {string} column
 * @extends {DropdownSelector}
 */
export class FieldTreeSubWorkTypesDropdown extends DropdownSelector {
  /**
   * Override method
   */
  handleClickOutsideOfComponent = e => {
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    this.setState({ opened: false });
    if (_.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };

  handleSelectedRow = (value, checked, name) => {
    if (checked === false && this.state.notUncheck === true) {
      return;
    }
    let temporarySelected = _.compact(this.state.temporarySelected);
    if (value) {
      if (checked) {
        temporarySelected = this.state.multiple
          ? _.union(temporarySelected, [value])
          : [value];
      } else {
        temporarySelected = this.state.multiple
          ? _.pull(temporarySelected, value)
          : [];
      }
    }
    let tempMultipleSelectedName;
    if (this.props.isMultipleSelectedName) {
      tempMultipleSelectedName = [...this.state.tempMultipleSelectedName];
      tempMultipleSelectedName = checked
        ? _.union(tempMultipleSelectedName, [name])
        : _.pull(tempMultipleSelectedName, name);
    }
    const temporarySelectedName = _.join(
      _.map(
        _.filter(this.state.options, op =>
          _.includes(temporarySelected, op[this.state.valueName])
        ),
        this.state.keyName
      ),
      ','
    );
    const temporaryHiddenSelectedOptions = this.mergeHiddenSelectedOptionsWithSelectedOptions();
    if (this.state.multiple) {
      this.setState({
        temporarySelected,
        tempMultipleSelectedName,
        temporarySelectedName,
        temporaryHiddenSelectedOptions,
      },
      () => {
        this.setValue();
      });
    } else {
      this.setState(
        {
          temporarySelected,
          tempMultipleSelectedName,
          temporarySelectedName,
          temporaryHiddenSelectedOptions,
          selectedName: temporarySelectedName,
          selected: temporarySelected,
        },
        () => {
          this.setValue();
          this.props.set(this.props.column, `${value}`);
        }
      );
    }
  };

  /**
   * Override method
   */
  handleOpen = e => {
    e.preventDefault();
    if (!this.state.opened) {
      if (this.tippyRef && this.tippyRef.current !== null) {
        this.tippyRef.current.hide(0);
      }
      if (this.state.reloadOptions) {
        this.setState(
          prevState => ({
            temporarySelected: prevState.selected,
            temporarySelectAll: prevState.selectAll,
            opened: true,
            loaded: false,
            isLoading: true,
            options: [],
          }),
          () => {
            this.loadData();
          }
        );
      } else {
        this.setState(prevState => ({
          temporarySelected: prevState.selected,
          temporarySelectAll: prevState.selectAll,
          opened: true,
        }));
      }
    } else {
      this.resetSelected();
    }
    if (this.state.opened && _.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };

  render() {
    const getName = () => {
      let name = this.state.label;
      if (
        this.state.temporarySelected.length > 0 ||
        this.state.selected.length > 0
      ) {
        const options = this.mergeHiddenSelectedOptionsWithSelectedOptions();
        if (options && options.length > 0) {
          name = _.join(_.map(options, this.state.keyName), ',');
        } else {
          name =
            this.state.temporarySelectedName ||
            this.state.selectedName ||
            this.state.label;
          if (_.isArray(name)) {
            name = _.join(name, ',');
          }
        }
      }
      return name;
    };

    const multipleGetName = () => {
      let name = this.state.label;
      if (this.state.tempMultipleSelectedName.length > 0) {
        name = _.join(this.state.tempMultipleSelectedName, ',');
      }
      return name;
    };
    const gotName = this.props.isMultipleSelectedName
      ? multipleGetName()
      : getName();
    return (
      <div
        className={`${
          !this.props.disabledDropdown ? 'disable-dropdown ' : ''
        }dropdown-multi-select${
          this.state.className !== '' ? ` ${this.state.className}` : ''
        }`}
        ref={this.parent}
      >
        <div
          className={`dropdown-multi-select__header ${
            this.state.opened ? ' show' : ''
          }`}
        >
          <a
            href=''
            className={`dropdown-select${this.state.opened ? ' show' : ''}`}
            onClick={this.handleOpen}
            style={this.state.dropdownSelectStyle}
            tabIndex={
              !this.props.disabledDropdown ? TAB_KEY_STATUS.disabled : TAB_KEY_STATUS.enabled
            }  
          >
            <span
              className={`dropdown-select__txt${
                this.state.expandable ? ' expandable' : ''
              }`}
            >
              {gotName}
            </span>
          </a>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </div>
        {this.state.opened && (
          <div
            className='dropdown dropdown--dropdown-list show'
          >
            <div
              className={`dropdown__item ${
                !_.isUndefined(this.props.widthClass)
                  ? this.props.widthClass
                  : ''
              } ${this.props.isHideHiddenItem ? '' : 'dropdown__item--hidden'}`}
            >
              {this.state.apiSearchKey !== '' && (
                <div className='dropdown-multi-select__item'>
                  <i className='i-search i-2x' />
                  <input
                    type='text'
                    id={`searchKey${this.uid}`}
                    className='SearchDropdown'
                    defaultValue={this.state.condition.name}
                    name='search'
                    placeholder={messageUtility.getMessage('I-000-090')}
                    onChange={this.setCondition}
                    autoComplete='off'
                  />
                </div>
              )}
              {!this.state.multiple && this.state.isOptional && (
                <div className='dropdown-single-select__item'>
                  <FormDropdownClearButton onClick={this.clearSelectedRow} />
                </div>
              )}
              {this.state.multiple && (
                <div className='dropdown-multi-select__item'>
                  <div className='dropdown-multi-select__checkall'>
                    <div className='btn-checkbox'>
                      <label htmlFor={`checkall-group-${this.uid}`}>
                        <input
                          id={`checkall-group-${this.uid}`}
                          type='checkbox'
                          checked={this.state.selectAll}
                          onClick={this.handleSelectAll}
                        />
                        <i className='i-square-checkbox i-2_5x' />
                      </label>
                    </div>
                    {this.props.hasTooltipAllSelect ? (
                      <Tippy
                        duration={10}
                        multiple={false}
                        arrow={true}
                        arrowType='sharp'
                        placement='bottom'
                        // maxWidth='160px'
                        html={
                          <div
                            style={{
                              fontSize: '10px',
                              lineHeight: '16px',
                              textAlign: 'left',
                              color: 'white',
                            }}
                          >
                            全選択する場合は最下部までスクロールしてください
                          </div>
                        }
                      >
                        <label htmlFor={`checkall-group-${this.uid}`}>
                          {messageUtility.getMessage('I-000-092')}
                        </label>
                      </Tippy>
                    ) : (
                      <label htmlFor={`checkall-group-${this.uid}`}>
                        {messageUtility.getMessage('I-000-092')}
                      </label>
                    )}
                  </div>
                </div>
              )}
              <div className='dropdown-multi-select__item'>
                <div
                  className='dropdown-multi-select__scroll'
                  id={this.targetId}
                >
                  <ul
                    className={
                      this.state.multiple ? 'multi-select' : 'single-select'
                    }
                  >
                    {_.map(this.state.options, option => (
                      <SelectableOption
                        key={option[this.state.valueName]}
                        option={option}
                        checked={this.checkedOption(option)}
                        targetId={this.id}
                        handleSelectedRow={this.handleSelectedRow}
                        state={this.state}
                        multiple={this.state.multiple}
                        itemWidthClass={
                          !_.isUndefined(this.props.itemWidthClass) &&
                          this.state.opened === true
                            ? this.props.itemWidthClass
                            : ''
                        }
                      />
                    ))}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(this.state.options)}
                      isLoading={this.state.isLoading}
                      callback={this.handleInview}
                      ignoreIndicator={true}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const SelectableOption = ({
  option,
  checked,
  targetId,
  handleSelectedRow,
  state,
  multiple,
  itemWidthClass,
}) => {
  return multiple ? (
    <li className={`multi-select__item ${itemWidthClass}`}>
      <div className='btn-checkbox'>
        <label
          htmlFor={`single-field-a-item-id-${
            option[state.valueName]
          }-${targetId}`}
        >
          <input
            id={`single-field-a-item-id-${option[state.valueName]}-${targetId}`}
            type='checkbox'
            checked={checked}
            onClick={() =>
              handleSelectedRow(
                option[state.valueName],
                !checked,
                option[state.keyName]
              )
            }
          />
          <i className='i-square-checkbox i-2_5x' />
        </label>
      </div>
      <div
        className={`multi-select__label tippy_target_${targetId}_${
          option[state.keyName]
        }_${option[state.valueName]}`}
        onClick={() =>
          handleSelectedRow(
            option[state.valueName],
            !checked,
            option[state.keyName]
          )
        }
      >
        {option[state.keyName]}
      </div>
    </li>
  ) : (
    <li className={`single-select__item ${itemWidthClass}`}>
      <label
        className='radio'
        htmlFor={`single-field-a-item-id-${
          option[state.valueName]
        }-${targetId}`}
      >
        <input
          id={`single-field-a-item-id-${option[state.valueName]}-${targetId}`}
          type='radio'
          checked={checked}
          onChange={() =>
            handleSelectedRow(
              option[state.valueName],
              !checked,
              option[state.keyName]
            )
          }
        />
        <RadioButtonIcon className='icon--1_6x' />
        <span
          className={`single-select__label tippy_target_${targetId}_${
            option[state.keyName]
          }_${option[state.valueName]}`}
        >
          {option[state.keyName]}
        </span>
      </label>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldTreeSubWorkTypesDropdown.jsx